const LegalLayout = ({ title, children }) => (
  <main data-testid="legal-page" className="py-14 md:py-20">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <a
        href="/"
        data-testid="legal-back-link"
        className="text-sm font-semibold text-brand-pink hover:underline"
      >
        ← Volver al inicio
      </a>
      <h1 className="mt-6 font-display font-bold tracking-tight text-brand-charcoal text-3xl md:text-4xl">
        {title}
      </h1>
      <p className="mt-2 text-sm text-brand-charcoal/50">Última actualización: julio de 2026</p>
      <div className="mt-10 space-y-10">{children}</div>
    </div>
  </main>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display font-semibold text-xl md:text-2xl text-brand-charcoal">{title}</h2>
    <div className="mt-3 text-sm md:text-base text-brand-charcoal/75 leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

export const Pending = () => (
  <span
    data-testid="legal-pending-badge"
    className="inline-block bg-brand-pink/10 text-brand-pink text-xs font-semibold uppercase tracking-wide rounded-full px-2.5 py-1 align-middle"
  >
    Pendiente de completar
  </span>
);

export default LegalLayout;
